import BasicAutoQueryController from "servicestack/auto-query/auto-query.controller";
import customerConfig from "emun.customer/customer.config";
import activityConfig from "emun.activity/activity.config";
import TagsPrompt from "servicestack/tags/tags-prompt";
import ContactPopup from "emun.customer/customer-contact.popover";
import ApprovalPrompt from "emun.auth/retailer-approval";
import RegistrationPrompt from "emun.auth/register-retailer.prompt";
import AssignRepPrompt from "emun.retailer/retailer-assign-rep-prompt";
import ChangeIdPrompt from "emun.customer/customer-change-id";
import addressValidatorPrompt from "webutils/address-validator-prompt";
import $session from "servicestack/session";
import cacheBusterGuid from 'webutils/services/cache-buster-guid';


export default class CustomerDetailsController extends BasicAutoQueryController {
  $onInit() {
    const $ctrl = this;
    super.$onInit && super.$onInit();
    $ctrl.ngModel = this;
    $ctrl.prompt = $ctrl.$ioc("retailerPrompt");
    $ctrl.navs = $ctrl.$state.getNav("cust.details");
    $ctrl.$session = $session;
    $ctrl.productImage = $ctrl.$appConfig.productImage.bind($ctrl.$appConfig);
    $ctrl.customerConfig = customerConfig;
    $ctrl.activityConfig = activityConfig;
    $ctrl.goals = {};
    $ctrl.changeIdPrompt = ChangeIdPrompt;
    $ctrl.openOrderAmount = 0;
    $ctrl.backlogTotal = 0;
    $ctrl.startDate = moment().subtract(12, "months").format("YYYY-MM-DD");
    $ctrl.endDate = moment().format("YYYY-MM-DD");
    $ctrl.ytdSales = {
      total: 0,
      count: 0,
      avg: 0,
      goal: 0,
    };
    $ctrl.lytdSales = {
      total: 0,
      count: 0,
      avg: 0,
    };
    $ctrl.lySales = {
      total: 0,
      count: 0,
      avg: 0,
    };
    $ctrl.quarterSales = {
      total: 0,
      count: 0,
      avg: 0,
      goal: 0,
    };
    $ctrl.lastquarterSales = {
      total: 0,
      count: 0,
      avg: 0,
    };
    $ctrl.mtdSales = {
      total: 0,
      count: 0,
      avg: 0,
      goal: 0,
    };
    $ctrl.lastmtdSales = $ctrl.lmtdSales = {
      total: 0,
      count: 0,
      avg: 0,
    };
    $ctrl.dailyInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.yesterdayInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.weekInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.lastweekInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.quarterInvoice = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    $ctrl.lastquarterInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.ytdInvoice = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    $ctrl.lastytdInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.lyInvoice = {
			total: 0,
			count: 0,
		};
    $ctrl.mtdInvoice = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    $ctrl.lastmtdInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.statuses = [];
    $ctrl.bus
      .send("QueryRegistrationStatuses.json?OrderBy=SortOrder")
      .then(function (response) {
        $ctrl.statuses = response.data.results;
      });

    $ctrl.$pageConfig.goTop();
    $ctrl.$on("$retailerApprovalSubmitted", () => $ctrl.query.load(true));
    $ctrl.$on("$retailerRequestSubmitted", () => $ctrl.query.load(true));
    //console.debug("CustomerDetailsController", $ctrl);
  }

  getQueries() {
    const $ctrl = this;
    return {
      query: {
        url: "QueryRetailers.json",
        pageSize: 1,
        orderBy: "CompanyName",
        autoLoad: true,
        append: false,
        criteria: {
          Id: $ctrl.customerId,
          includeSalesData: 1,
        },
        onLoaded: (args) => $ctrl.onRetailerLoaded(args),
      },
      ytdSalesQuery: {
        url:
          "QuerySalesDailyCustomerTotals.json?Fields=CustomerName&Sum=OrderTotal,OrderCount&dateRange=YTD&GroupBy=CustomerID,CustomerName&customerId=" +
          encodeURIComponent($ctrl.customerId),
        autoLoad: true,
        onLoaded: (args) => $ctrl.onYtdSalesLoaded(args, $ctrl.ytdSales),
      },
      lastytdSalesQuery: {
        url:
          "QuerySalesDailyCustomerTotals.json?Fields=CustomerName&Sum=OrderTotal,OrderCount&dateRange=LYTD&GroupBy=CustomerID,CustomerName&customerId=" +
          encodeURIComponent($ctrl.customerId),
        autoLoad: true,
        onLoaded: (args) => $ctrl.onYtdSalesLoaded(args, $ctrl.lytdSales),
      },
      lastySalesQuery: {
        url:
          "QuerySalesDailyCustomerTotals.json?Fields=CustomerName&Sum=OrderTotal,OrderCount&dateRange=LastYear&GroupBy=CustomerID,CustomerName&customerId=" +
          encodeURIComponent($ctrl.customerId),
        autoLoad: true,
        onLoaded: (args) => $ctrl.onYtdSalesLoaded(args, $ctrl.lySales),
      },
      mtdSalesQuery: {
        url:
          "QuerySalesDailyCustomerTotals.json?Fields=CustomerName&Sum=OrderTotal,OrderCount&dateRange=MTD&GroupBy=CustomerID,CustomerName&customerId=" +
          encodeURIComponent($ctrl.customerId),
        autoLoad: true,
        onLoaded: (args) => $ctrl.onYtdSalesLoaded(args, $ctrl.mtdSales),
      },
      lastmtdSalesQuery: {
        url:
          "QuerySalesDailyCustomerTotals.json?Fields=CustomerName&Sum=OrderTotal,OrderCount&dateRange=LYMTD&GroupBy=CustomerID,CustomerName&customerId=" +
          encodeURIComponent($ctrl.customerId),
        autoLoad: true,
        onLoaded: (args) => $ctrl.onYtdSalesLoaded(args, $ctrl.lmtdSales),
      },
      quarterSalesQuery: {
        url:
          "QuerySalesDailyCustomerTotals.json?Fields=CustomerName&Sum=OrderTotal,OrderCount&dateRange=Quarter&GroupBy=CustomerID,CustomerName&customerId=" +
          encodeURIComponent($ctrl.customerId),
        autoLoad: true,
        onLoaded: (args) => $ctrl.onYtdSalesLoaded(args, $ctrl.quarterSales),
      },
      lastquarterdSalesQuery: {
        url:
          "QuerySalesDailyCustomerTotals.json?Fields=CustomerName&Sum=OrderTotal,OrderCount&dateRange=QuarterLY&GroupBy=CustomerID,CustomerName&customerId=" +
          encodeURIComponent($ctrl.customerId),
        autoLoad: true,
        onLoaded: (args) =>
          $ctrl.onYtdSalesLoaded(args, $ctrl.lastquarterSales),
      },
      backlogSalesQuery: {
        url:
          "QuerySalesDailyCustomerVendorTotals.json?Fields=CustomerName&Sum=Backlog,Allocated&GroupBy=CustomerID,CustomerName&customerId=" +
          encodeURIComponent($ctrl.customerId),
        autoLoad: true,
        onLoaded: function (args) {
          $ctrl.backlogTotal = 0;
          $ctrl.allocatedTotal = 0;
          args.results.forEach(function (res) {
            $ctrl.backlogTotal = res.sumBacklog;
            $ctrl.allocatedTotal = res.sumAllocated;
          });
        },
      },
      propertiesQuery: {
        url:
          "QueryRetailerProperties.json?RetailerId=" +
          encodeURIComponent($ctrl.customerId),
        autoLoad: false,
        onLoaded: (args) =>
          ($ctrl.customer.additionalProperties = args.results),
      },
      openOrdersQuery: {
        url:
          "QueryCartsJoin.json?StatusIn=Open,On Hold&GroupBy=Status&Sum=GrandTotal&RetailerId=" +
          encodeURIComponent($ctrl.customerId),
        autoLoad: true,
        pageSize: 1000,
        scrollTop: false,
        onLoaded: function (args) {
          $ctrl.openOrderAmount = 0;
          $ctrl.openOrderAmount = 0;
          args.results.forEach(function (res) {
            switch (res.status) {
              case "Open":
                $ctrl.openOrderAmount = res.sumGrandTotal;
                break;
              case "On Hold":
                $ctrl.onHoldOrderAmount = res.sumGrandTotal;
                break;
              default:
              // code block
            }
          });
        },
      },
      dailyInvoiceQuery: {
        url:
          "QueryInvoiceYOYTotals.json?Sum=TotalInvoiceToday,TotalInvoiceCountToday,TotalInvoiceYesterday,TotalInvoiceCountYesterday,TotalInvoiceWeekToDate,TotalInvoiceCountWeekToDate,TotalInvoiceQuarterToDate,TotalInvoiceCountQuarterToDate,TotalInvoiceQuarterToDateLastYear,TotalInvoiceCountQuarterToDateLastYear,TotalInvoiceYearToDate,TotalInvoiceCountYearToDate,TotalInvoiceYearToDateLastYear,TotalInvoiceCountYearToDateLastYear,TotalInvoiceLastYear,TotalInvoiceCountLastYear,TotalInvoiceMonthToDate,TotalInvoiceCountMonthToDate,TotalInvoiceMonthToDateLastYear,TotalInvoiceCountMonthToDateLastYear&GroupBy=CustomerID&CustomerID=" +
          encodeURIComponent($ctrl.customerId),
        autoLoad: true,
        pageSize: 1000,
        onLoaded: function (args) {
          if (args.total > 0) {
            var res = args.first;
            $ctrl.dailyInvoice.total = res.sumTotalInvoiceToday;
            $ctrl.dailyInvoice.count = res.sumTotalInvoiceCountToday;
            $ctrl.yesterdayInvoice.total = res.sumTotalInvoiceYesterday;
            $ctrl.yesterdayInvoice.count = res.sumTotalInvoiceCountYesterday;
            $ctrl.weekInvoice.total = res.sumTotalInvoiceWeekToDate;
            $ctrl.weekInvoice.count = res.sumTotalInvoiceCountWeekToDate;
            $ctrl.quarterInvoice.total += res.sumTotalInvoiceQuarterToDate;
            $ctrl.quarterInvoice.count += res.sumTotalInvoiceCountQuarterToDate;
            $ctrl.lastquarterInvoice.total +=
              res.sumTotalInvoiceQuarterToDateLastYear;
            $ctrl.lastquarterInvoice.count +=
              res.sumTotalInvoiceCountQuarterToDateLastYear;
            var percent = Math.round(
              ($ctrl.quarterInvoice.total / $ctrl.lastquarterInvoice.total) *
                100
            );
            if ($ctrl.lastquarterInvoice.total === 0) {
              percent = 100;
            }
            if (percent < 100) {
              $ctrl.quarterInvoice.percent = 100 - percent;
              $ctrl.quarterInvoice.trend = "down";
            } else if (percent > 100) {
              $ctrl.quarterInvoice.percent = percent - 100;
              $ctrl.quarterInvoice.trend = "up";
            } else {
              $ctrl.quarterInvoice.percent = 100;
              $ctrl.quarterInvoice.trend = "neutral";
            }
            $ctrl.ytdInvoice.total += res.sumTotalInvoiceYearToDate;
            $ctrl.ytdInvoice.count += res.sumTotalInvoiceCountYearToDate;
            $ctrl.lastytdInvoice.total += res.sumTotalInvoiceYearToDateLastYear;
            $ctrl.lastytdInvoice.count +=
              res.sumTotalInvoiceCountYearToDateLastYear;
            percent = Math.round(
              ($ctrl.ytdInvoice.total / $ctrl.lastytdInvoice.total) * 100
            );
            if ($ctrl.lastytdInvoice.total === 0) {
              percent = 100;
            }
            if (percent < 100) {
              $ctrl.ytdInvoice.percent = 100 - percent;
              $ctrl.ytdInvoice.trend = "down";
            } else if (percent > 100) {
              $ctrl.ytdInvoice.percent = percent - 100;
              $ctrl.ytdInvoice.trend = "up";
            } else {
              $ctrl.ytdInvoice.percent = 100;
              $ctrl.ytdInvoice.trend = "neutral";
            }
            $ctrl.lyInvoice.total += res.sumTotalInvoiceLastYear;
					  $ctrl.lyInvoice.count += res.sumTotalInvoiceCountLastYear;
            $ctrl.mtdInvoice.total += res.sumTotalInvoiceMonthToDate;
            $ctrl.mtdInvoice.count += res.sumTotalInvoiceCountMonthToDate;
            $ctrl.lastmtdInvoice.total +=
              res.sumTotalInvoiceMonthToDateLastYear;
            $ctrl.lastmtdInvoice.count +=
              res.sumTotalInvoiceCountMonthToDateLastYear;
            percent = Math.round(
              ($ctrl.mtdInvoice.total / $ctrl.lastmtdInvoice.total) * 100
            );
            if ($ctrl.lastmtdInvoice.total === 0) {
              percent = 100;
            }
            if (percent < 100) {
              $ctrl.mtdInvoice.percent = 100 - percent;
              $ctrl.mtdInvoice.trend = "down";
            } else if (percent > 100) {
              $ctrl.mtdInvoice.percent = percent - 100;
              $ctrl.mtdInvoice.trend = "up";
            } else {
              $ctrl.mtdInvoice.percent = 100;
              $ctrl.mtdInvoice.trend = "neutral";
            }
          }
        },
      },
      goalsQuery: {
        url:
          "QueryRetailerGoals.json?Sum=SalesGoalThisMonth,SalesGoalThisYear,SalesGoalLastYear,SalesGoalLastMonth,SalesGoalThisQuarter&GroupBy=vendorID&CustomerID=" +
          encodeURIComponent($ctrl.customerId) + ":0",
        autoLoad: true,
        pageSize: 1000,
        onLoaded: function (args) {
          if (args.total > 0) {
            args.results.forEach(function (res) {
              $ctrl.goals.month += Math.round(res.sumSalesGoalThisMonth);
              $ctrl.goals.quarter += Math.round(res.sumSalesGoalThisQuarter);
              $ctrl.goals.year += Math.round(res.sumSalesGoalThisYear);
            });
            $ctrl.goals.monthPercent = Math.round(
              ($ctrl.mtdSales.total / $ctrl.goals.month) * 100
            );
            $ctrl.goals.quarterPercent = Math.round(
              ($ctrl.quarterSales.total / $ctrl.goals.quarter) * 100
            );
            $ctrl.goals.yearPercent = Math.round(
              ($ctrl.ytdSales.total / $ctrl.goals.year) * 100
            );
            $ctrl.ytdSales.goal = $ctrl.goals.year;
            $ctrl.mtdSales.goal = $ctrl.goals.month;
          }
        },
      },
    };
  }

  getStatus(name) {
    let $ctrl = this;
    var statuses = $ctrl.statuses.filter((s) => s.name == name);
    if (statuses.length > 0) return statuses[0];
  }

  onYtdSalesLoaded(args, field) {
    const $ctrl = this;
    $ctrl.$pageConfig.goTop();
    if (args.total > 0) {
      field.total = Math.round(args.first.sumOrderTotal);
      field.count = args.first.sumOrderCount;
      field.avg = field.total / field.count;
    }
  }

  onRetailerLoaded(args) {
    const $ctrl = this;
    if (args.total === 0) {
      return $ctrl.$modals.alert("Could not find: " + $ctrl.customerId);
    }
    $ctrl.customer = args.first;
    $ctrl.$broadcast("$retailerLoaded");
    $ctrl.$pageConfig.goTop();
    $ctrl.customer.location =
      $ctrl.customer.address +
      " " +
      $ctrl.customer.city +
      ", " +
      $ctrl.customer.state +
      " " +
      $ctrl.customer.zip;
    $ctrl.$state.current.customTitle = $ctrl.customer.companyName;
    $ctrl.propertiesQuery.load();
    //if ($ctrl.customer.contact) {
    //	$ctrl.contact = JSON.parse($ctrl.customer.contact);
    //}
    $ctrl
      .$ioc("NgMap")
      .getMap({ id: "map1" })
      .then((map) => {
        $ctrl.$ioc("$timeout")(function () {
          let center = map.getCenter();
          google.maps.event.trigger(map, "resize");
          map.setCenter(center);
        });
      });
    if ($ctrl.autoEdit === "true") {
      $ctrl.autoEdit = "false";
      $ctrl.edit();
    }
    $ctrl.submissionId = $ctrl.customer.tags.AuthorizationForm;
    if ($ctrl.submissionId) {
      $ctrl.bus
        .send(`QueryFormSubmissions/${$ctrl.submissionId}.json`)
        .then(({ data }) => {
          if (data.results.length) {
            $ctrl.submission = {
              label: "register-retailer",
              data: data.results[0].data,
            };
            $ctrl.customer.meta = Object.assign(
              {},
              $ctrl.customer.meta,
              data.results[0].data
            );
          }
        });
    }
  }

  openMap() {
    const $ctrl = this;
    const geoSearchString =
      $ctrl.customer.address +
      " " +
      $ctrl.customer.city +
      ", " +
      $ctrl.customer.state +
      " " +
      $ctrl.customer.zip;
    window.open("http://www.google.com/maps/place/" + geoSearchString);
  }

  editTags(retailer) {
    const $ctrl = this;
    return TagsPrompt.open({
      title: retailer.id + " - " + retailer.companyName + " Tags...",
      tags: retailer.tags,
      principalId: retailer.id,
      shard: "Retailer",
    }).then(() => $ctrl.query.load(true));
  }

  changeID() {
    const $ctrl = this;
    return $ctrl.changeIdPrompt
      .open({ retailer: this.customer })
      .then(function (obj) {
        $ctrl.$state.transitionTo("cust.details", {
          customerId: obj.updated,
        });
      });
  }

  edit() {
    const $ctrl = this;
    return $ctrl.prompt.edit(this.customer).then(() => $ctrl.query.load(true));
  }

  load() {
    const $ctrl = this;

    return $ctrl.query.load.apply($ctrl.query, arguments);
  }

  fireResizeMap() {
    const $ctrl = this;
    $ctrl.$broadcast("resizeMap");
  }

  contactPopup(customer, contactId) {
    const $ctrl = this;
    ContactPopup.open({ customer: customer });
  }

  startOrder() {
    const $ctrl = this;
    $ctrl.$cart.createPrompt({
      retailer: $ctrl.customer,
      status: "Cart",
    });
  }

  approvalPrompt() {
    const $ctrl = this;
    return ApprovalPrompt.open({
      title:
        $ctrl.customer.id +
        " - " +
        $ctrl.customer.companyName +
        " Required Approval...",
      retailer: $ctrl.customer,
    }).then((res) => $ctrl.query.load(true));
  }

  assignRep() {
    const $ctrl = this;
    return AssignRepPrompt.open({
      title:
        $ctrl.customer.id +
        " - " +
        $ctrl.customer.companyName +
        " Assign Rep...",
      retailer: $ctrl.customer,
    }).then((res) => $ctrl.query.load(true));
  }

  registrationPrompt() {
    const $ctrl = this;
    return RegistrationPrompt({
      title:
        $ctrl.customer.id +
        " - " +
        $ctrl.customer.companyName +
        " Registration...",
      retailer: $ctrl.customer,
    }).then(() => $ctrl.query.load(true));
  }

  approve(retailer) {
    let $ctrl = this;
    let url = `ApproveRetailer.json`;
    return $ctrl.$modals
      .confirm("Approve this retailer request?", "Retailer Request")
      .result.then(() => {
        return $ctrl.bus
          .send(url, retailer)
          .then((res) => $ctrl.query.load(true));
      });
  }

  complete(retailer) {
    let $ctrl = this;
    let url = `CompleteRetailer.json`;
    return $ctrl.$modals
      .confirm("Complete this retailer request?", "Retailer Request")
      .result.then(() => {
        return $ctrl.bus
          .send(url, retailer)
          .then((res) => $ctrl.query.load(true));
      });
  }

  decline(retailer) {
    let $ctrl = this;
    let url = `DeclineRetailer.json`;
    return $ctrl.$modals
      .confirm("Decline this retailer request?", "Retailer Request")
      .result.then(() => {
        return $ctrl.bus
          .send(url, retailer)
          .then((res) => $ctrl.query.load(true));
      });
  }

  validateAddress(customer) {
    const $ctrl = this;
    addressValidatorPrompt
      .open({ model: customer, key: customer.id })
      .then(function (address) {
        if (address.valid && address.selected) {
          customer.companyName = address.selected.companyName;
          customer.address = address.selected.address;
          customer.address2 = address.selected.address2;
          customer.city = address.selected.city;
          customer.state = address.selected.state;
          customer.zip = address.selected.zip;
          customer.tags["latitude"] = address.selected.latitude;
          customer.tags["longitude"] = address.selected.longitude;
          $ctrl.query.bus
            .send("UpdateRetailer", customer)
            .then((res) => $ctrl.query.load(true));
        }
      });
  }
  runOpenOrders() {
    const $ctrl = this;
    const url = `/service/RunReport?displayName=OpenOrders&reportName=OpenOrders&customer=${$ctrl.customer.id}&billTos=${$ctrl.customer.id}&billTo=${$ctrl.customer.id}&imageFromBucket=True&` + cacheBusterGuid();
    window.open(url, "_blank");
  }
  runTopSellersXLS() {
    const $ctrl = this;
    const url = `/service/RunReport?displayName=TopSellingItems&reportName=TopSellingItems&includeImages=true&imageFromBucket=True&customer=${$ctrl.customer.id}&billTo=${$ctrl.customer.id}&billTos=${$ctrl.customer.id}&customer=${$ctrl.customer.id}&sortBy=Qty&source=SalesOrders&top=All&output=xlsx&orderStatuses=Open,On Hold,Complete,Completed,Review&startDate=${$ctrl.startDate}&endDate=${$ctrl.endDate}&exportedOrdersOnly=true` + cacheBusterGuid();
    window.open(url, "_blank");
  }
  runTopSellersPDF() {
    const $ctrl = this;
    const url = `/service/RunReport?displayName=TopSellingItems&reportName=TopSellingItems&includeImages=true&imageFromBucket=True&customer=${$ctrl.customer.id}&billTo=${$ctrl.customer.id}&billTos=${$ctrl.customer.id}&customer=${$ctrl.customer.id}&sortBy=Qty&source=SalesOrders&top=All&output=pdf&orderStatuses=Open,On Hold,Complete,Completed,Review&startDate=${$ctrl.startDate}&endDate=${$ctrl.endDate}&exportedOrdersOnly=true` + cacheBusterGuid();
    window.open(url, "_blank");
  }
}
